import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    width: 400px;
    max-width: 90%;
`;

const FormGroup = styled.div`
    margin-bottom: 15px;
    
    label {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
    }
    
    select {
        width: 100%;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
`;

const RedButton = styled.button`
    background-color: #f44336;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    
    &:hover {
        background-color: #d32f2f;
    }
`;

const GreenButton = styled.button`
    background-color: #4CAF50;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    
    &:hover {
        background-color: #388E3C;
    }
`;

export interface TimeRangePickerProps {
    onSelect: (startTime: string, endTime: string) => void;
    onClose: () => void;
    onUnavailable: () => void;
    selectedDate: Date;
    guideId: string;
}

const TimeRangePicker: React.FC<TimeRangePickerProps> = ({
    onSelect,
    onClose,
    onUnavailable,
    selectedDate
}) => {
    const [startTime, setStartTime] = useState('09:00');
    const [endTime, setEndTime] = useState('17:00');

    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 8; hour <= 20; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const formattedHour = hour.toString().padStart(2, '0');
                const formattedMinute = minute.toString().padStart(2, '0');
                options.push(`${formattedHour}:${formattedMinute}`);
            }
        }
        return options;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        onSelect(startTime, endTime);
        onClose();
    };

    const handleUnavailable = async () => {
        onUnavailable();
        onClose();
    };

    const timeOptions = generateTimeOptions();

    return (
        <ModalContainer onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()}>
                <h3>Select Time Range for {moment(selectedDate).format('MMMM D, YYYY')}</h3>
                <form onSubmit={handleSubmit}>
                    <FormGroup>
                        <label htmlFor="startTime">Start Time</label>
                        <select
                            id="startTime"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        >
                            {timeOptions.map((time) => (
                                <option key={`start-${time}`} value={time}>
                                    {time}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                    <FormGroup>
                        <label htmlFor="endTime">End Time</label>
                        <select
                            id="endTime"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        >
                            {timeOptions.map((time) => (
                                <option key={`end-${time}`} value={time}>
                                    {time}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                    <ButtonContainer>
                        <RedButton type="button" onClick={handleUnavailable}>
                            Mark Unavailable
                        </RedButton>
                        <GreenButton type="submit">
                            Set Availability
                        </GreenButton>
                    </ButtonContainer>
                </form>
            </ModalContent>
        </ModalContainer>
    );
};

export default TimeRangePicker;

 